module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-18.308592f2.jpg";